import React from "react";
import FuelRecords from '../../../Features/Tables/FuelManagement'

const All = () => {
  return <div>
    <FuelRecords />
  </div>;
};

export default All;
